import Button from "components/Button";
import CallButton from "components/CallButton";
import LeadLanding from "components/LeadLanding";
import KnowledgeBaseCallout from "components/KnowledgeBaseCallout";
import PageHeader from "components/PageHeader";
import { quoteIdForCase, quotePathById } from "helpers/me-home";
import { useCreateCaseQuote } from "hooks/useCreateCaseQuote";
import { useMeHome } from "hooks/useMeHome";

import { leadCaseCopy, type LeadCaseLandingModel } from "./lead-landing";

function GetQuote({ caseId }: { caseId: string | undefined }) {
  const { create, isCreating, failed } = useCreateCaseQuote(caseId);
  return (
    <>
      <Button
        variant="compact"
        isLoading={isCreating}
        loadingText="Getting your quote…"
        onClick={() => void create()}
      >
        Get a quote
      </Button>
      {failed && (
        <p role="alert" className="basis-full text-base text-oat-700">
          We couldn’t put your quote together online. Please call us and we’ll
          help.
        </p>
      )}
    </>
  );
}

/** The top of a case before Dispatch: who the family is here for, what
 * happens next, the line to call, and the way to the quote (or to get one).
 * Arrangement actions are not offered here. */
export default function LeadCaseLanding({
  model,
  caseId,
}: {
  model: LeadCaseLandingModel;
  caseId: string | undefined;
}) {
  const copy = leadCaseCopy(model);
  const { home, isLoading } = useMeHome();
  const quoteId = home ? quoteIdForCase(home, caseId) : null;

  return (
    <div className="flex flex-col gap-2">
      <PageHeader
        eyebrow="Arrangements"
        title={copy.title}
        description={copy.body}
      />
      <div className="mt-4 flex flex-wrap items-center gap-3">
        <CallButton variant="compact" className="px-6" />
        {quoteId !== null && (
          <Button href={quotePathById(quoteId)} variant="compact">
            View your quote
          </Button>
        )}
        {quoteId === null && !isLoading && <GetQuote caseId={caseId} />}
      </div>
      <LeadLanding cards={[]} steps={copy.steps} />
      {caseId && (
        <KnowledgeBaseCallout
          subject={{ kind: "case", id: caseId }}
          className="mt-8"
        />
      )}
    </div>
  );
}
